require.register("modules/m05/m05-activity/page-7/page-7", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page7 = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {
    //Only shows the links that have resources in the modals.
    setTimeout(() => {
      let $modals = view.$el.find('.resource-modals .modal');
      $modals.each((index, modal) => {
        if(!$(modal).find('.resource-items').is(':empty')){
          $('.resource-modal-links').find(`[data-target='#${modal.id}']`).show();
        }
      });
    }, 500);
  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page7;

  
});

